export default "__VITE_ASSET__828a1908__"